<script lang="ts">
	import type { Writable, Readable } from "svelte/store";
	import { fly } from 'svelte/transition';
	export let desktopSearchVizStore: Writable<boolean>;
        //$:console.log("search: " + $desktopSearchVizStore)
        import Search from "./Search.svelte";
  import { clickOutside } from '../index';
  
  const clickOutsideHandler = (e)=> {
    $desktopSearchVizStore = false
  }
</script>
<div class="relative" >
    {#if $desktopSearchVizStore}
<div class="main-search-container" transition:fly>
    <div class="search-bg mx-auto" use:clickOutside={{desktopTriggerElement: document.getElementById('header-button-container')}}
    on:CLICK_OUTSIDE={clickOutsideHandler}>
        <p class="svelte-o3045t">Search <i class="fa-duotone fa-magnifying-glass"></i></p>
   
    <Search/>
</div>
</div>
{/if}
</div>

<style lang="scss">
    .main-search-container {
      width: 100%;
      position: absolute;
      top: 2px;
    }
  
    .search-bg {
      display: block;
      padding: 2rem;
      border-radius: 2rem;
      background-color: rgba($color: #333, $alpha: 0.9);
      max-width: 650px;
  
      > p {
        color: white;
        text-align: center;
        font-weight: 700;
      }
    }
  </style>